<template>
    <div class="pt-7 container">
        <div class="flex justify-content-end mt-4">
            <Button label="Criar Grupo" @click="createGroup" />
        </div>
        <div class="mt-3">
            <div v-for="grupo in grupos" :key="grupo.id" class="bg-white shadow-1 border-round-sm p-4 mb-4 cursor-pointer" @click.stop="exibirGrupo(grupo.id)">
                <div class="flex justify-content-between align-items-center">
                    <div class="flex flex-column gap-2">
                        <div>{{ grupo.plano }}</div>
                        <div class="text-xl font-medium text-color "> {{ grupo.nome }}</div>
                    </div>
                    <div class="d-flex gap-3">

                        <Button v-tooltip.top="'Editar grupo'" icon="pi pi-pencil" severity="secondary" text rounded
                            aria-label="Editar grupo" @click.stop="editarGrupo(grupo.id)" />
                        <Button v-tooltip.top="'Excluir grupo. \n Essa ação é irreversível.'" icon="pi pi-trash"
                            severity="secondary" text rounded aria-label="Excluir grupo"
                            @click.stop="excluirGrupo(grupo.id)" />
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, computed } from 'vue';
import { useStore } from 'vuex'

import Button from 'primevue/button';
import { useRouter } from 'vue-router';
const router = useRouter();
const store = useStore()

import { supabase } from '@/supabase'

const grupos = ref([])
const turma = computed(() => store.state.turma)
onMounted(() => {
    carregarGrupos()
})

async function carregarGrupos(){
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
    .from('grupos')
    .select('id, nome, metodo_criacao, quem_escolheu, idDaAula, grupos_planos(plano, planos(titulo)), grupos_estudantes(numero_grupo, estudante)')
    
    .eq('idDaAula', turma.value.idDaAula)
    .order('id', { ascending: false })

    

    if(data){
        console.log('grupo')
        console.log(data)
        data.forEach(item => {
            if (item.grupos_planos[0] !== undefined){
                grupos.value.push({ id: item.id, nome: item.nome, plano: item.grupos_planos[0].planos.titulo })
            }else{
                grupos.value.push({ id: item.id, nome: item.nome, plano: '' })
            }
           
        })
    }

    console.log(grupos.value)
    store.dispatch('updateLoading', false)
}

const createGroup = () => {
    router.push({ name: 'AdicionarGrupo' });
}

const editarGrupo = (id) => {
    router.push({ path: '/professor/turma/grupos/editar', query: { id } })
}

function exibirGrupo(id){
    router.push({ path: '/professor/turma/grupos/exibir', query: { id } })
}

async function excluirGrupo(id){
    store.dispatch('updateLoading', true)
    const { data, error } = await supabase
    .from('grupos')
    .delete()
    .eq('id', id)
    
    if(error){
        alert(error.message)
        store.dispatch('updateLoading', false)
        return
    }

    let naoRemovido = grupos.value.filter(grupo => grupo.id != id)
    grupos.value = naoRemovido
    store.dispatch('updateLoading', false)



}


</script>